import { Avatar } from "@mui/material";
import { getItem } from "../../utils/storage";
import { getColorByName } from "../../utils/nameColors";
import { useEffect, useRef } from "react";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import isToday from "dayjs/plugin/isToday";
import isYesterday from "dayjs/plugin/isYesterday";
import advancedFormat from "dayjs/plugin/advancedFormat";

dayjs.extend(relativeTime);
dayjs.extend(isToday);
dayjs.extend(isYesterday);
dayjs.extend(advancedFormat);

export const formatTimestamp = (timestamp: string) => {
  const time = dayjs(timestamp);

  if (time.isToday()) {
    return time.fromNow(); // e.g., "2 hours ago"
  }

  if (time.isYesterday()) {
    return "Yesterday";
  }

  return time.format("MMM D, YYYY"); // e.g., "Apr 15, 2025"
};

interface props {
  messages: any;
}
const ChatMessages = ({ messages }: props) => {
  const user = getItem("user");

  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <div
      ref={scrollRef}
      className="flex-1 max-h-full p-5 space-y-6 overflow-auto custom-scrollbar xl:space-y-8 xl:p-6"
    >
      {messages?.map((mess: any, index: number) => {
        const { senderId, content, timestamp, senderName } = mess;
        const color = getColorByName(senderName);
        const time = formatTimestamp(timestamp);
        return (
          <div
            key={index}
            className={`flex gap-2 ${senderId === user?.user?.id ? "justify-end" : "items-start "}`}
          >
            <div className="w-[50px] h-[50px]">
              <Avatar
                sx={{
                  backgroundColor: `${color}`,
                }}
                className="object-cover object-center w-[50px] h-[50px] overflow-hidden rounded-full"
              >
                {senderName.charAt(0).toUpperCase()}
              </Avatar>
            </div>
            <div className="">
              <div
                className={`
                ${senderId === user?.user?.id ? "px-3 py-2 rounded-lg bg-brand-500 text-white dark:bg-brand-500 rounded-tr-sm" : "px-3 py-2 rounded-lg bg-gray-100 dark:bg-white/5 text-gray-800 dark:text-white/90 rounded-tl-sm"}`}
              >
                <p className="text-sm ">{content}</p>
              </div>
              <p className="mt-2 text-gray-500 text-theme-xs dark:text-gray-400">
                {senderName}, {time}
              </p>
            </div>
          </div>
        );
      })}
      {/* <div className="flex items-start gap-4">
        <div className="w-10 h-10 overflow-hidden rounded-full">
          <img
            alt="Lindsey Curtis profile"
            className="object-cover object-center w-full h-full"
            src="./images/user/user-17.jpg"
          />
        </div>
        <div className="">
          <div className="px-3 py-2 rounded-lg bg-gray-100 dark:bg-white/5 text-gray-800 dark:text-white/90 rounded-tl-sm">
            <p className="text-sm ">
              I want to make an appointment tomorrow from 2:00 to 5:00pm?
            </p>
          </div>
          <p className="mt-2 text-gray-500 text-theme-xs dark:text-gray-400">
            Lindsey Curtis, 30 mins
          </p>
        </div>
      </div>
      <div className="flex justify-end">
        <div className="text-right">
          <div className="px-3 py-2 rounded-lg bg-brand-500 text-white dark:bg-brand-500 rounded-tr-sm">
            <p className="text-sm ">
              If don’t like something, I’ll stay away from it.
            </p>
          </div>
          <p className="mt-2 text-gray-500 text-theme-xs dark:text-gray-400">
            2 hours ago
          </p>
        </div>
      </div> */}

      {/* <div className="flex items-start gap-4">
        <div className="w-10 h-10 overflow-hidden rounded-full">
          <img
            alt="Lindsey Curtis profile"
            className="object-cover object-center w-full h-full"
            src="./images/user/user-17.jpg"
          />
        </div>
        <div className="">
          <div className="mb-2 w-full max-w-[270px] overflow-hidden rounded-lg">
            <img
              alt="chat"
              className="object-cover"
              src="./images/chat/chat.jpg"
            />
          </div>
          <div className="px-3 py-2 rounded-lg bg-gray-100 dark:bg-white/5 text-gray-800 dark:text-white/90 rounded-tl-sm">
            <p className="text-sm ">Please preview the image</p>
          </div>
          <p className="mt-2 text-gray-500 text-theme-xs dark:text-gray-400">
            Lindsey Curtis, 2 hours ago
          </p>
        </div>
      </div> */}
    </div>
  );
};

export default ChatMessages;
